/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupMemberId
 */
export interface GroupMemberId {
    /**
     * 
     * @type {number}
     * @memberof GroupMemberId
     */
    id?: number;
}

/**
 * Check if a given object implements the GroupMemberId interface.
 */
export function instanceOfGroupMemberId(value: object): value is GroupMemberId {
    return true;
}

export function GroupMemberIdFromJSON(json: any): GroupMemberId {
    return GroupMemberIdFromJSONTyped(json, false);
}

export function GroupMemberIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupMemberId {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function GroupMemberIdToJSON(value?: GroupMemberId | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

